import { render, staticRenderFns } from "./DashboardCriLayout.vue?vue&type=template&id=37de6d54"
import script from "./DashboardCriLayout.vue?vue&type=script&lang=js"
export * from "./DashboardCriLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardCriLayout.vue?vue&type=style&index=0&id=37de6d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports